import { render, staticRenderFns } from "./StaticIBEOffer.vue?vue&type=template&id=83c2d4a2&lang=pug&"
import script from "./StaticIBEOffer.vue?vue&type=script&lang=js&"
export * from "./StaticIBEOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports